import i18n from "@/i18n";
import store from "./store";
import { api } from "./auth/api";


type MessageRecord = Record<string, any>;

const isRecord = (value: unknown): value is Record<string, any> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const treatLocale = (value: any) => {
    let aValue;
    if (typeof value === 'object') {
        aValue = value?.id.split('-');
    }
    else aValue = value.split('-');
    return {
        language: aValue[0],
        country: aValue[1]
    }
}

function isPlainObject(value: unknown): value is MessageRecord {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}

function deepMergeMessages(base: MessageRecord, incoming: MessageRecord): MessageRecord {
    const merged: MessageRecord = { ...base };
    Object.keys(incoming).forEach((key) => {
        const baseValue = merged[key];
        const incomingValue = incoming[key];
        if (isPlainObject(baseValue) && isPlainObject(incomingValue)) {
            merged[key] = deepMergeMessages(baseValue, incomingValue);
        } else {
            merged[key] = incomingValue;
        }
    });
    return merged;
}

// Function to fetch and set the messages for the selected language
export async function loadMessages(options: { language: string, country?: string }) {
    const locale = `${options.language}${options.country ? '-' + options.country : ''}`;
    const URI = `/odm-configuration/api/1/odm-configuration/translation/translate/`;
    api()
        .post(URI, options)
        .then((response) => {
            if (!response.data) {
                console.error(`No settled language for the specific locale ${locale} in database!`);
                return;
            }
            const currentMessages = i18n.global.getLocaleMessage(locale) as MessageRecord;
            const apiMessages = response.data as MessageRecord;
            const mergedMessages = deepMergeMessages(currentMessages || {}, apiMessages || {});
            i18n.global.setLocaleMessage(locale, mergedMessages as any);
            i18n.global.locale.value = locale; // Set the current locale
            localStorage.setItem("locale", locale);
        })
        .catch((e) => {
            console.error("Error occurred while fetching translations:", e);
        });
}

export const getTranslations = async (value: any, checkLocal?: boolean) => {
  let msgValue: any;

  if (checkLocal) {
    msgValue = localStorage.getItem("locale") || value;

    const option = store
      .getters["authModule/getUserConnected"]
      .preferredLanguages.filter(
        (item: any) => item.id === msgValue || item.id === msgValue.id
      );

    store.state.authModule!.user.selectedLanguage = option[0];
  } else {
    msgValue = value;
    store.state.authModule!.user.selectedLanguage = value;
  }

  const { language, country } = treatLocale(msgValue);

  try {
    await loadMessages({ language, country });
  } catch {
    await loadMessages({ language });
  }
};